import ScoreDetailsHeader from '../Components/Common/ScoreDetailsHeader';
import FactorsPanel from './Components/Factors/FactorsPanel';
import UIStrings from '@/Utils/UIStrings';

function PersonalityScoreDetails() {
    return (
        <div className="bg-card rounded-xl border p-5">
            <ScoreDetailsHeader description={UIStrings.PersonalityScoreDetailsHeader} />
            <FactorsPanel />
        </div>
    );
}

export default PersonalityScoreDetails;
